import { render, staticRenderFns } from "./addEmployeeEditReason.vue?vue&type=template&id=4ec57036&scoped=true"
import script from "./addEmployeeEditReason.vue?vue&type=script&lang=js"
export * from "./addEmployeeEditReason.vue?vue&type=script&lang=js"
import style0 from "./addEmployeeEditReason.vue?vue&type=style&index=0&id=4ec57036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec57036",
  null
  
)

export default component.exports